export default __webpack_public_path__ + "static/media/21.c4a5b75d.jpg";